import React, { useEffect, useState } from 'react';
import { FormControl, FormControlLabel } from '@mui/material';
import CustomCheckbox from '../components/CustomCheckbox';
export const FormInputMultiCheckbox = ({ name, setValue, onChange, initialValues, options = [], sx }) => {
  const [selectedItems, setSelectedItems] = useState(initialValues ?? []);

  // Update selectedItems when initialValues change
  useEffect(() => {
    if (initialValues) {
      setSelectedItems(initialValues);
    }
  }, [initialValues]);

  const handleSelect = value => {
    const isPresent = selectedItems.indexOf(value);
    if (isPresent !== -1) {
      const remaining = selectedItems.filter(item => item !== value);
      setSelectedItems(remaining);
    } else {
      setSelectedItems(prevItems => [...prevItems, value]);
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(name, [...new Set(selectedItems)]);
    } else {
      setValue(name, [...new Set(selectedItems)]);
    }
  }, [selectedItems]);

  return (
    <FormControl sx={sx}>
      {options.map(option => (
        <FormControlLabel
          className={selectedItems.includes(option.value) ? 'active' : ''}
          key={option.value}
          label={option.label}
          control={
            <CustomCheckbox
              checked={selectedItems.includes(option.value)}
              onChange={() => handleSelect(option.value)}
            />
          }
        />
      ))}
    </FormControl>
  );
};
